export const buildHydraulicRequestUrl = (
  apiUrl: string,
  icestupaId: string,
  startDate: string,
  endDate: string
): string => {
  const params = new URLSearchParams();
  if (icestupaId && icestupaId !== 'All') {
    params.set('icestupa_id', icestupaId);
  }
  if (startDate) params.set('start_date', `${startDate}T00:00:00Z`);
  if (endDate) params.set('end_date', `${endDate}T23:59:59Z`);
  return `${apiUrl}/dashboard/hydraulic?${params.toString()}`;
};

export const isHydraulicSourceStale = (
  sourceEndDate: string,
  now = new Date()
): boolean => {
  if (!sourceEndDate) return false;
  const sourceEnd = new Date(`${sourceEndDate}T23:59:59Z`);
  if (Number.isNaN(sourceEnd.getTime())) return false;
  return now.getTime() - sourceEnd.getTime() >= 7 * 24 * 60 * 60 * 1000;
};
